var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChSdReplaceImmediatelyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26758 5C9.03738 3.66667 10.9626 3.66667 11.7324 5L18.6602 17C19.43 18.3333 18.4673 20 16.9277 20H3.07227C1.53267 20 0.570043 18.3333 1.33984 17L8.26758 5Z",
    stroke: "#F2060A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5783 14.284L9.4523 7.13H10.5303L10.4043 14.284H9.5783ZM9.9983 17.084C9.8023 17.084 9.6343 17.014 9.4943 16.874C9.3543 16.734 9.2843 16.566 9.2843 16.37C9.2843 16.174 9.3543 16.006 9.4943 15.866C9.6343 15.726 9.8023 15.656 9.9983 15.656C10.1943 15.656 10.3623 15.726 10.5023 15.866C10.6423 16.006 10.7123 16.174 10.7123 16.37C10.7123 16.566 10.6423 16.734 10.5023 16.874C10.3623 17.014 10.1943 17.084 9.9983 17.084Z",
    fill: "#F2060A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChSdReplaceImmediatelyIcon);
export default __webpack_public_path__ + "static/media/ch-sd-replace-immediately-icon.3c83e39ff0b4b6004ac03358ddc87aa5.svg";
export { ForwardRef as ReactComponent };